export const URL_EMAIL_SERVICE: string = "https://www2.auge.com.br/";